






























require 'vendor.charts.js'

module.exports =
  name: 'reports'
  metaInfo: -> { title: this.$t('Reports') }
